export const commercialPackageFilterFields = ['label'];

export const commercialPackageSelectLabel = object => object.value;
